/* eslint-disable @typescript-eslint/naming-convention */
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import './amplify.config';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
